import React, { useState, useEffect } from 'react';
import styles from './Appointments.module.scss';
import clsx from 'clsx';
import AppointmentList from './appointmentList/AppointmentList';
import {
	getAllUpcommingAppointmentsBySalesAgentId,
	getAllUpcommingAppointmentsForAllSalesAgent,
} from '../../../api/Appointments/appointments.api';
import {
	Divider,
	IconButton,
	Tooltip,
	Card,
	CardContent,
	Button,
} from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { useHistory } from 'react-router';
//redux
import { connect } from 'react-redux';
import { upcommingAppointments } from '../../../redux/appointments/actions';
import { pastAppointments } from '../../../redux/appointments/actions';

const Appointments = ({
	upcommingAppointmentsArray,
	pastAppointmentsArray,
	upcommingAppointments,
	pastAppointments,
	salesAgentId,
	filterByDate,
}) => {
	const [upcommingAppointmentsArr, setUpcommingAppointmentsArr] = useState(
		[]
	);
	const [pastAppointmentsArr, setPastAppointmentsArr] = useState([]);
	const history = useHistory();

	useEffect(() => {
		upcommingAppointments();
		pastAppointments();

		console.log('upcommingAppointments in appointments', salesAgentId);
	}, []);

	useEffect(() => {
		if (salesAgentId && salesAgentId !== 'allSalesAgents') {
			getAllUpcommingAppointmentsBySalesAgentId(
				salesAgentId,
				filterByDate,
				(returned) => {
					setUpcommingAppointmentsArr(returned);
				}
			);
		} else if (salesAgentId === 'allSalesAgents') {
			getAllUpcommingAppointmentsForAllSalesAgent(
				filterByDate,
				(returned) => {
					setUpcommingAppointmentsArr(returned);
				}
			);
		} else {
			setUpcommingAppointmentsArr(upcommingAppointmentsArray);
			setPastAppointmentsArr(pastAppointmentsArray);
		}
	}, [salesAgentId, filterByDate]);

	return (
		<div className={styles.appointments_group}>
			<div className={styles.appointments_group_title}>
				<h3 className={styles.appointments_title}>
					Upcoming appointment
				</h3>
				{/* <IconButton
					className={styles.calendarButton}
					onClick={() => {
						history.push({ pathname: '/agenda' });
					}}
				>
					<Tooltip title='View agenda'>
						<CalendarTodayIcon className={styles.m0} />
					</Tooltip>
				</IconButton> */}
			</div>
			{upcommingAppointmentsArr.length > 0 ? (
				<>
					<Card
						className={styles.appointments_card_group}
						variant='outlined'
					>
						<CardContent>
							{upcommingAppointmentsArr
								.slice(0, 1)
								.map((appointment, index) => {
									return (
										<AppointmentList
											key={index}
											appointment={appointment}
										/>
									);
								})}
						</CardContent>
					</Card>
				</>
			) : (
				<>
					<Card
						className={styles.appointments_card_group}
						variant='outlined'
					>
						<CardContent>
							<p className={styles.cardHeader}>
								There’s no upcoming appointments
							</p>
							<Button
								className={styles.btn_primary}
								aria-label='Go to agenda'
								onClick={() => {
									history.push({ pathname: '/agenda' });
								}}
							>
								Schedule a meeting
							</Button>
						</CardContent>
					</Card>
				</>
			)}
			<Divider className={styles.mt_lg} />
		</div>
	);
};

const mapStateToProps = (state) => ({
	upcommingAppointmentsArray: state.appointments.upcommingAppointments,
	pastAppointmentsArray: state.appointments.pastAppointments,
});

export default connect(mapStateToProps, {
	upcommingAppointments,
	pastAppointments,
})(Appointments);
